import { FC, PropsWithChildren } from 'react';
import Head from 'next/head';
import ErrorOffline from '@/modules/error/components/ErrorOffline';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';

interface IOfflineContainerProps extends PropsWithChildren<{}> {}

const OfflineContainer: FC<IOfflineContainerProps> = ({ children }) => {
  const { isOnline, handleOnlineStatus } = useNetworkStatus();

  return (
    <>
      <Head>
        <link
          as="image"
          href="https://s3.ir-thr-at1.arvanstorage.com/mofidapp/error/offline.webp"
        />
      </Head>
      {children}
      {!isOnline && (
        <ErrorOffline className="page-full" onClick={handleOnlineStatus} />
      )}
    </>
  );
};

export default OfflineContainer;
